import { ControlMenuItemType } from '../control-menu';
import { isActionReplayable } from './last-tool-selection-menu.utils';

export interface SelectionTrackingCallbacks {
  recordSelection(itemId: string): void;
  recordCheckboxSelection(itemId: string, enabled: boolean): void;
  isMultipleSelection(): boolean;
}

export const wrapItemsForSelectionTracking = (
  items: ControlMenuItemType[],
  callbacks: SelectionTrackingCallbacks,
  parentActionId?: string,
  isParentActionReplayable: boolean = true
): ControlMenuItemType[] =>
  items.map((item) => {
    if (item.type === 'radiogroup') {
      return {
        ...item,
        setValue: (value: string): void => {
          if (parentActionId) {
            if (isParentActionReplayable) {
              callbacks.recordSelection(parentActionId);
            }
          } else {
            callbacks.recordSelection(value);
          }
          item.setValue(value);
        },
      };
    }

    if (item.type === 'action') {
      const replayable = isActionReplayable(item);
      return {
        ...item,
        onClick: (): void => {
          if (replayable) {
            callbacks.recordSelection(item.id);
          }
          item.onClick();
        },
        children: item.children
          ? wrapItemsForSelectionTracking(
              item.children,
              callbacks,
              item.id,
              replayable
            )
          : undefined,
      };
    }

    if (item.type === 'toggle') {
      return {
        ...item,
        setValue: (value: boolean): void => {
          if (parentActionId && isParentActionReplayable) {
            callbacks.recordSelection(parentActionId);
          }
          item.setValue(value);
        },
      };
    }

    if (item.type === 'checkbox') {
      return {
        ...item,
        setValue: (value: boolean): void => {
          if (parentActionId && isParentActionReplayable) {
            callbacks.recordSelection(parentActionId);
          } else if (!parentActionId) {
            if (callbacks.isMultipleSelection()) {
              callbacks.recordCheckboxSelection(item.id, value);
            } else {
              callbacks.recordSelection(item.id);
            }
          }
          item.setValue(value);
        },
        children: item.children
          ? wrapItemsForSelectionTracking(
              item.children,
              callbacks,
              parentActionId,
              isParentActionReplayable
            )
          : undefined,
      };
    }

    return item;
  });
